<template>
  <section>
    <div>
      <div :class="[{ 'be-loading-active': isBusy }]">
        <div class="table-responsive">
          <table class="table m-0 p-0 dataTable text-nowrap">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    @change="toggleSelectAll"
                    :checked="areAllSelected"
                  />
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Payment Date
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Type
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Customer
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Amount (₦)
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Account Paid
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Payment ID
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Order ID
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load the list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="pN in altPaymentNotification" :key="pN.id" v-else>
                <td>
                  <input
                    :checked="pN.isChecked"
                    type="checkbox"
                    class="custom-checkbox"
                    :value="pN.id"
                    @change="selectNotification(pN.id)"
                  />
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(pN.paymentDate) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ pN.paymentType }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#2463EB] cursor-pointer"
                >
                  <span
                    v-if="pN.customerId"
                    @click.prevent="
                      details(pN.customerId, '/customers/account/')
                    "
                  >
                    {{ pN.customerName }}
                  </span>
                  <p v-else>N/A</p>
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatMoney(pN.amount) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ pN.bankName }}<br />
                  {{ pN.accountPaid }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] cursor-pointer"
                >
                  <p
                    class="text-[#2463EB]"
                    v-if="pN.paymentId"
                    @click="getPaymentDetails(pN.paymentId)"
                  >
                    {{ pN.paymentId.substring(0, 7) }}
                  </p>
                  <p class="text-[#353535]" v-else>N/A</p>
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] cursor-pointer"
                >
                  <p
                    class="text-[#353535]"
                    v-if="!pN.orderId || pN.orderId == 'NA'"
                  >
                    N/A
                  </p>
                  <p class="text-[#2463EB]" v-else>
                    <!-- @click.prevent="details(pN.orderId, '/orders/')" -->
                    {{ pN.orderId.substring(0, 7) }}
                  </p>
                </td>
                <td>
                  <span
                    class="flex items-center gap-[4px] max-w-max w-full"
                    :class="[
                      'badge',
                      {
                        'badge-success': pN.deliveryStatus,
                        'badge-danger': !pN.deliveryStatus,
                      },
                    ]"
                  >
                    <span
                      class="w-[10px] h-[10px] rounded-[1px]"
                      :style="{
                        backgroundColor: pN.deliveryStatus
                          ? '#16a249'
                          : '#EF5253',
                      }"
                    ></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">{{
                      pN.deliveryStatus ? "Read" : "Unread"
                    }}</span>
                  </span>
                </td>
              </tr>
              <tr v-if="!altPaymentNotification.length && !loading">
                <td colspan="12">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="fa-solid fa-truck text-[#2463EB]"
                    ></span>
                  </div>
                  <h3
                    class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px"
                  >
                    You don't have any payment Notifications.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="pageNumber"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <!-- payment details -->
    <div class="modal fade" id="mod-paymentDetails" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-full"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <div>
              <h4
                class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
              >
                Payment Details
              </h4>
            </div>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Amount</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="number"
                  placeholder="Enter Amount"
                  v-model.number="singlePaymentDetails.amount"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Customer</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  disabled
                  type="text"
                  placeholder="Enter Customer"
                  v-model="singlePaymentDetails.customer"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Account ID</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Account ID"
                  v-model="singlePaymentDetails.accountId"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Reference ID</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Amount"
                  v-model="singlePaymentDetails.referenceId"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Channel</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Channel"
                  v-model="singlePaymentDetails.channel"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Fees</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Fees"
                  v-model="singlePaymentDetails.fees"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Payment Date</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Payment Date"
                  v-model="singlePaymentDetails.paymentDate"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Completed Date</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Completed Date"
                  v-model="singlePaymentDetails.completedDate"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Created By</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Created By"
                  v-model="singlePaymentDetails.createdBy"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Payment Notes</label
              >
              <div>
                <input
                  disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Payment Notes"
                  v-model="singlePaymentDetails.paymentNote"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end gap-[8px] w-full mt-[16px]">
            <button
              data-dismiss="modal"
              aria-hidden="true"
              style="width: 200px"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
            >
              <span>Done</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- filter modal -->
    <div class="modal fade" id="mod-filter" role="dialog" tabindex="-1">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h3
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h3>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  placeholder="Select an option"
                  v-model="filter.status"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                >
                  <option value="">All</option>
                  <option
                    v-for="stat in status"
                    :key="stat.text"
                    :value="stat.value"
                  >
                    {{ stat.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Payment Type</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.Type"
                >
                  <option value="">All</option>
                  <option value="Transfer In">Transfer In</option>
                  <option value="Order Payment">Order Payment </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Date start</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.dateStart"
              />
            </div>
            <div>
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Date End</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.dateEnd"
              />
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="clearFilter"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getPaymentNotification"
            >
              <span v-if="isBusy">Busy...</span>
              <span v-else>Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <ModalOrder :activeTab="activeTab" /> -->
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import Pagination from "../../components/Pagination.vue";
import AccountPostingCheckbox from "../../components/Posting/AccountPostingCheckbox.vue";
import { bus } from "../../main";
// import ModalOrder from "../ManageOrders/ModalOrder.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  components: {
    AccountPostingCheckbox,
    Pagination,
    // ModalOrder,
  },

  data() {
    return {
      filter: {
        status: null,
        Type: "",
        dateStart: moment().format("1999-01-01"),
        dateEnd: moment().format("YYYY-MM-DD"),
      },
      isBusy: false,
      isModalVisible: false,
      activeTab: "order",
      loading: true,
      count: 0,
      page: 0,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      paymentNotification: [],
      paymentDetailsList: [],
      paymentDetails: {
        id: null,
        count: 0,
        page: 0,
        pageNumber: 1,
        pageSize: 10,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
      },
      singlePaymentDetails: {
        amount: 0,
        customer: "",
        accountId: "",
        referenceId: "",
        channel: "",
        fees: "",
        paymentDate: "",
        completedDate: "",
        createdBy: "",
        paymentNote: "",
      },
      isSelectAll: false,
      selectedIds: [],
      altPaymentNotification: [],
      status: [
        { text: "Read", value: true },
        { text: "Unread", value: false },
      ],
      maxDate: "",
    };
  },

  created() {
    this.getPaymentNotification();
    bus.$on("markRead", this.markAsRead);
    bus.$on("filterView", this.viewFilter);
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    areAllSelected() {
      return this.altPaymentNotification.every((pN) => pN.isChecked);
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },

  methods: {
    clearFilter() {
      (this.filter.read = null),
        (this.filter.Type = ""),
        (this.filter.dateStart = moment().format("1999-01-01"));
      this.filter.dateEnd = moment().format("YYYY-MM-DD");
    },
    details(id, link) {
      this.$router.push({
        path: link + id,
      });
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    showPaymentDetails() {
      $("#mod-paymentDetails").modal("show");
    },

    viewAdd() {
      $("#mod-add-posting").modal("show");
    },

    viewFilter() {
      $("#mod-filter").modal("show");
    },
    async markAsRead() {
      this.isBusy = true;
      if (this.selectedIds.length < 1) {
        return this.$toast.warning("You must select a notification.", {
          icon: true,
          rtl: false,
        });
      }
      await this.$http
        .post(`/PaymentNotification/read/${this.selectedIds}`)
        .then(function(res) {
          this.altPaymentNotification = [];
          this.isSelectAll = false;
          this.getPaymentNotification();
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    async getPaymentNotification() {
      this.altPaymentNotification = [];
      this.selectedIds = [];
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          `/paymentNotification?PageNumber=${this.pageNumber}&PageSize=${
            this.pageSize
          }&Read=${
            this.filter.status == "" ? "" : this.filter.status
          }&paymentType=${
            this.filter.Type == "" ? "" : this.filter.Type
          }&startDate=${
            this.filter.dateStart == ""
              ? ""
              : moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          }&endDate=${
            this.filter.dateEnd == ""
              ? ""
              : moment(this.filter.dateEnd).format("YYYY-MM-DD 00:00:00")
          }`
        )
        .then(function(res) {
          this.paymentNotification = res.data.data;
          this.formatNotificationArray(res.data.data);
          this.pageNumber = res.data.pageNumber;
          this.$store.dispatch("getPaymentNotificationCount");
          this.pageSize = res.data.pageSize;
          this.count = res.data.count;
          this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
          this.hasPrev = res.data.hasPrev;
          this.hasNext = res.data.hasNext;
          this.isBusy = false;
          this.loading = false;
          $("#mod-filter").modal("hide");
          this.clearFilter();
        })
        .catch(function() {
          this.isBusy = false;
          this.loading = false;
          $("#mod-filter").modal("hide");
        });
    },

    async getPaymentDetails(id) {
      this.isBusy = true;
      await this.$http
        .get(`/PaymentNotification/paymentDetails/${id}`)
        .then(function(res) {
          let data = res.body;
          this.pageNumber = res.data.pageNumber;
          this.pageSize = res.data.pageSize;
          this.count = res.data.count;
          this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
          this.hasPrev = res.data.hasPrev;
          this.hasNext = res.data.hasNext;
          this.isBusy = false;
          this.viewPaymentDetails(data);
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    viewPaymentDetails(c) {
      this.showPaymentDetails();
      this.singlePaymentDetails.amount = c.amount;
      this.singlePaymentDetails.customer = c.customerName;
      this.singlePaymentDetails.accountId = c.accountId;
      this.singlePaymentDetails.referenceId = c.referenceId;
      this.singlePaymentDetails.channel = c.channel;
      this.singlePaymentDetails.fees = c.fees;
      this.singlePaymentDetails.paymentDate =
        c.paymentDate == null
          ? "No Date Found"
          : new Date(c.paymentDate).toLocaleDateString("en-US");
      this.singlePaymentDetails.completedDate =
        c.completedDate == null
          ? "No Date Found"
          : new Date(c.completedDate).toLocaleDateString("en-US");
      this.singlePaymentDetails.createdBy = c.createdBy;
      this.singlePaymentDetails.paymentNote = c.paymentNote;
    },
    selectAll() {
      for (var i = 0; i < this.altPaymentNotification.length; i++) {
        this.altPaymentNotification[i].isChecked = true;
        this.selectedIds.push(this.altPaymentNotification[i].id);
      }
      this.isSelectAll = true;
    },

    selectNotification(id) {
      if (this.selectedIds.includes(id)) {
        let filterSelected = this.selectedIds.filter((item) => item != id);
        this.selectedIds = filterSelected;
      } else {
        this.selectedIds.push(id);
      }
    },

    async markOneItemAsRead(id) {
      this.isBusy = true;
      await this.$http
        .post(`/PaymentNotification/read/${id}`)
        .then(function(res) {
          this.altPaymentNotification = [];
          this.isBusy = false;
          this.isSelectAll = false;
          this.getPaymentNotification();
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    formatNotificationArray(arr) {
      for (var i = 0; i < arr.length; i++) {
        let obj = {
          isChecked: false,
          id: arr[i].id,
          paymentDate: arr[i].paymentDate,
          paymentType: arr[i].paymentType,
          customerId: arr[i].customerId,
          customerName: arr[i].customerName,
          amount: arr[i].amount,
          bankName: arr[i].bankName,
          accountPaid: arr[i].accountPaid,
          paymentId: arr[i].paymentId,
          orderId: arr[i].orderId,
          deliveryStatus: arr[i].deliveryStatus,
        };
        this.altPaymentNotification.push(obj);
      }
    },

    deSelectAll() {
      for (var i = 0; i < this.altPaymentNotification.length; i++) {
        this.altPaymentNotification[i].isChecked = false;
      }
      this.isSelectAll = false;
      this.selectedIds = [];
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },

    goToPayment(id) {
      this.$router.push("/payments/" + id);
    },

    updateFilter(filter) {
      this.$store.commit("updateAccountPosting", filter);
    },

    prev() {
      this.pageNumber -= 1;
      this.getPaymentNotification();
    },

    next() {
      this.pageNumber += 1;
      this.getPaymentNotification();
    },

    gotoPage(page) {
      this.pageNumber = page;
      this.getPaymentNotification();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getPaymentNotification();
    },
    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      this.altPaymentNotification.forEach((pN) => {
        pN.isChecked = isChecked;
      });
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 20px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
